import Error from './Error/Error';
import Info from './Info/Info';
import Pending from './Pending/Pending';
import Restricted from './Restricted/Restricted';
import Unauthorized from './Unauthorized/Unauthorized';

const Fallback = {
    Error,
    Info,
    Pending,
    Restricted,
    Unauthorized
};

export default Fallback;
